import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { Driver } from '@commons/models/domain/Driver';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { VehicleTachoSlot } from '@commons/models/domain/VehicleTacho';
import { MappingService } from '@commons/services/mapping/mapping.service';
import { getActiveTachoSlot } from '@src/app/utils/vehicle-fncs';

@Component({
  selector: 'app-tacho-status-full-list',
  templateUrl: './tacho-status-full-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tacho-status-full-list.component.scss']
})
export class TachoStatusFullListComponent {
  
  @Input('data') set data(value: Vehicle) {
    this.vehicle = value;

    if (!value.TC) {
      this.isLoading = false;
      this.isNoDriver = true;
    }
    else if (value.Tacho) {
      this.setTachoData();
    }
  }

  public vehicle: Vehicle;
  public isLoading: boolean = true;
  public isNoDriver: boolean;
  public currentStateTacho?: number;
  public driver?: Driver;
  public activeSlotData!: VehicleTachoSlot;

  constructor(
    private changeDetRef: ChangeDetectorRef,
  ) { }

  private setTachoData(): void {
    if (this.vehicle.Tacho) {
      const slotData = getActiveTachoSlot(this.vehicle);
      if (slotData) {
        this.setActiveSlot(slotData);
        return;
      }
      this.isNoDriver = true;
    }
    this.isLoading = false;
    this.changeDetRef.markForCheck();
  }

  private setActiveSlot(slotData: VehicleTachoSlot): void {
    this.currentStateTacho = MappingService.convertTachoStatus(slotData.St);
    this.activeSlotData = {...(slotData || {})};
    this.isLoading = false;
  }

}
